<template>
    <div class="fxn-body">
        <header class="fxn-header" v-bind:class="{ asideactive: isActive,'zhongkongtai': ver_type === '7' }">
            <div class="fxn-logo">
                <router-link v-show="!isActive" to="/">M+管理系统</router-link>
                <el-radio-group v-model="isCollapse" @change="OpenCollapse">
                    <el-radio-button v-if="isActiveshow" :label="false">
                        <i class="iconfont iconmenu"></i>
                    </el-radio-button>
                    <el-radio-button v-else :label="true">
                        <i class="iconfont iconmenu"></i>
                    </el-radio-button>
                </el-radio-group>
            </div>
            <!-- Logo End  -->
            <Tel></Tel>
            <!-- Tel End -->
            <div class="fxn-header-right">
                <AiSip></AiSip>
                <SnatchTime></SnatchTime>
                <Message></Message>
                <div class="item">
                    <span @click="OpenLink(1)">
                        <img v-if="head_img == ''" src="../assets/img/unuserhead.png" alt="" style="width: 2rem; height: 2rem;border-radius: 50%;">
                        <img v-else :src="TextUrl + head_img" alt="" style="width: 2rem; height: 2rem;border-radius: 50%;">
                    </span>
                    <el-dropdown trigger="click">
                        <span class="el-dropdown-link">
                            {{username + (mem_type != '1' ? '@'+sub_sign : '' )}}<i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                            <!-- <el-dropdown-item @click.native="OpenLink(1)">会员中心</el-dropdown-item>
                            <el-dropdown-item @click.native="OpenLink(3)">问题反馈</el-dropdown-item> -->
                            <el-dropdown-item @click.native="OpenLink(4)">消息中心</el-dropdown-item>
                            <el-dropdown-item @click.native="editPass= true">修改密码</el-dropdown-item>
                            <el-dropdown-item @click.native="logoutForm">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
            </div>
            <!-- Header Right End -->
        </header>
        <!-- 修改密码 -->
        <el-dialog title="修改密码" :visible.sync="editPass" :close-on-click-modal="true" :modal-append-to-body="true">
            <el-form :model="EditPassForm" :rules="EditPassRules" ref="EditPassForm" >
                <el-form-item label="旧密码" :label-width="formLabelWidth" prop="oldPassword">
                    <el-input v-if="editPass" type="password" v-model="EditPassForm.oldPassword" autocomplete="off" maxlength="18" placeholder="请输入旧密码" show-password></el-input>
                </el-form-item>

                <el-form-item label="新密码" :label-width="formLabelWidth" prop="newPassword">
                    <el-input v-if="editPass" type="password" v-model="EditPassForm.newPassword" autocomplete="off" maxlength="16" placeholder="请输入新密码" show-password @input="newpass"></el-input>
                </el-form-item>

                <el-form-item label="确认密码" :label-width="formLabelWidth" prop="reNewPassword">
                    <el-input v-if="editPass" type="password" v-model="EditPassForm.reNewPassword" autocomplete="off" maxlength="16" placeholder="输入确认密码" show-password  @input="reNewpass"></el-input>
                </el-form-item>
                <el-form-item :label-width="formLabelWidth">
                    注：密码长度8~16位，同时包含数字+字母
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editPass = false">取 消</el-button>
                <el-button type="primary" @click="editButton('EditPassForm')">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改密码 End -->

        <!-- 合规催收协议 -->
        <el-dialog :visible.sync="legalProtocol" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" :center="true">
            <div class="fxn-index-docx">
                <h2>合法合规催收承诺书</h2>
                <br>
                <p>本人承诺在处理有关委托催收的逾期账户还款事宜期间，合法合规对债务人进行催收作业，承诺禁止以下不合规行为：</p>
                <p>1、对债务人高频呼叫，使用网络电话、APP验证码、线上通话、短信等方式骚扰债务人；</p>
                <p>2、未核实联系人身份通过电话、短信等方式泄露债务人个人信息；</p>
                <p>3、辱骂、恐吓客户，恶意夸张逾期造成后果；</p>
                <p>4、通过信息网络或者通讯工具、公共平台实施扬言、揭发、恶意举报、诬陷债务人的行为，散布不良言论；</p>
                <p>5、私自承诺减免，未清楚告知欠款结清金额；</p>
                <p>6、承诺协助进行相关查询核实但未履行及反馈；</p>
                <p>7、拨打已经标记为敏感的号码；</p>
                <p>8、一切P图造假行为，包括但不限于以P图的方式威胁、恐吓债务人，包含P图伪造征信报告、律师函及政府、公检法相关文件，及相关公民个人信息、虚假通缉令。</p>
                <p>9、向客户或第三方通过任何渠道发送非我司审批通过使用的信息模板，或未按照模板使用条件违规发送，及向客户以外的第三方进行催款行为；</p>
                <p>10、客户或第三方有投诉意向或欺诈情况未预警进行安抚，无视客户或第三方反馈情况继续催收；</p>
                <p>11、未按照拨打规则用电话、短信、线上通话、呼死你软件等恶意骚扰客户或第三方；</p>
                <p>12、以故意隐瞒、误导、欺骗、欺瞒等恶性方式催收；</p>
                <p>13、激怒或引导客户产生过激情绪和行为：客户在沟通过程中有轻生、自残、犯罪的过激情绪表现，催收员未在线安抚反而进一步激化或引导客户产生过激行为；</p>
                <p>14、在催收过程中通过辱骂、暴力、恐吓、侮辱、诽谤等不当催收方式；</p>
                <p>15、通过各种渠道肆意散播公示客户个人隐私信息和欠款信息，私发客户或家人照片编辑侮辱文字或沟通中使用不得当的用词，包括但不限于辱骂、暴力、恐吓、侮辱、诽谤、违法等文字信息内容；</p>
                <p>16、贪污受贿：与客户有金钱往来，让客户还款至自己的私人账户或私下向客户索取不定数额的财务帮其减免或答应客户其他要求，私掏腰包替客户还款，向客户索要分期乐账号密码等；</p>
                <p>17、冒充公检法机构身份恐吓、欺瞒、哄骗客户；</p>
                <p>18、教唆或指引欠款人用违法、违规途径筹钱还款；</p>
                <p>19、将催收系统和公司内部其它系统内容截图发送至外界；</p>
                <p>20、伪造、挪用公司或机关公章使用；</p>
                <br>
                <p>本人保证一切按贵公司合规规范作业，出现任何风险投诉，本人及公司承担不限于罚款、停案、终止合作、赔偿经济损失的所有责任！</p>
                <br>
            </div>
            <div class="is_agreen">
                <el-radio v-model="isAgreen" label="1">我已阅读并遵守《合法合规催收承诺书》</el-radio>        
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="agreenProtocol">&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;</el-button>
            </div>
        </el-dialog>
        <!-- 合规催收协议 End -->
    </div>
</template>

<script>
    let ws = '';
    import Tel from './Tel'
    import User from './User'
    import Message from './Message'
    import SnatchTime from './SnatchTime'
    import AiSip from './AiSip'
    export default {
        components: {
            Tel,
            User,
            Message,
            SnatchTime,
            AiSip,
        },
        data(){
            //较验
            var validateNewPass = (rule, value, callback) => {
                let numReg = /\d+/;
                let letterReg =  /[a-zA-Z]+/;
                if(value === '') {
                    callback(new Error('请输入密码'));
                }else if(!numReg.test(value) || !letterReg.test(value)){
                    callback(new Error('密码需同时包含数字，字母'));
                } else {
                    if (this.EditPassForm.reNewPassword !== '') {
                        this.$refs.EditPassForm.validateField('reNewPassword');
                    }
                    callback();
                }
            };
            var validaterePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.EditPassForm.newPassword) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return{
                ver_type: '1',
                //菜单
                isCollapse: false,
                isActive: false,
                isActiveshow: false,

                //合规催收协议
                legalProtocol: false,
                isAgreen: '',

                //用户信息
                head_img: '',
                sub_sign: '',
                username: '',
                TextUrl: this.TextUrl,
                mem_type: '',

                //修改密码
                formLabelWidth: '120px',
                editPass: false,
                EditPassForm: {
                    oldPassword: '',
                    newPassword: '',
                    reNewPassword: '',
                },
                EditPassRules: {
                    oldPassword: [
                        { required: true, message: '请输入旧密码', trigger: 'blur' },
                    ],
                    newPassword:[
                        { required: true, validator: validateNewPass, trigger: 'blur' },
                        { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' },
                    ],
                    reNewPassword:[
                        { required: true, validator: validaterePass, trigger: 'blur' },
                        { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' }
                    ]
                },
            }
        },
        methods:{
            //修改密码
            editButton(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.post('/Fapi/Member/changePwd',{
                            oldPassword: this.EditPassForm.oldPassword,
                            newPassword: this.EditPassForm.newPassword,
                            reNewPassword: this.EditPassForm.reNewPassword
                        })
                        .then( res=>{
                            let{ msg, code, data } = res.data
                            if( code !== 1 ){
                                this.$message({
                                    message: msg,
                                    type: 'error'
                                });
                            }else{
                                this.$message({
                                    message: '修改成功!请牢记您的新密码！',
                                    type: 'success'
                                });
                                this.editPass = false;
                                localStorage.clear();
                                sessionStorage.clear(); 
                                this.$router.go(0)
                                location.href = '/Login'
                            }
                        })
                    }
                })
            },

            //退出登录
            logoutForm(){
                this.post('/Fapi/Member/loginout')
                .then( res=>{
                    let { msg, code, data } = res.data
                    if(code !== 1){
                        this.$message({
                            message: msg,
                            type: 'error'
                        });
                    }else{
                        this.$message({
                            message: '退出登录',
                            type: 'success'
                        });
                        localStorage.clear();
                        sessionStorage.clear();
                        this.$router.go(0)                                                                                                                                                                                                                                               
                        location.href = '/Login'
                    }
                })
            },

            //菜单切换
            OpenCollapse(){
                this.OpenAside.$emit('CheckAside',this.isCollapse)
                if(this.isCollapse == true){
                    this.isActive = true;
                    this.asideactive = false;
                    this.isActiveshow = true;

                }else{
                    this.isActive = false;
                    this.asideactive = true;
                    this.isActiveshow = false;
                }
            },


            //同意合规催收协议
            agreenProtocol(){
                if(this.isAgreen !== '1') {
                    this.$message({
                        message: '请勾选“我已阅读并遵守《合法合规催收承诺书》”！',
                        type: 'error'
                    })
                    return false
                } else {
                    this.post('/Fapi/Member/readCommitmentStatus')
                    .then( res => {
                        let { code , msg } = res.data
                        if( code !== 1){
                            this.$message({
                                message: msg,
                                type: 'error'
                            })
                        } else {
                            this.legalProtocol = false;
                            let user = JSON.parse(localStorage.getItem('user'));  //更新localStorage
                            user.memberInfo.commitment_status = "1";
                            localStorage.setItem('user',JSON.stringify(user))

                            this.lnitialPassChange();           //初始密码弹框
                        }
                    })
                } 
            },

            //初始密码修改弹框
            lnitialPassChange(){
                if(localStorage.getItem('pass_status')  && !this.legalProtocol){
                    this.editPass = true
                    this.$message({
                        message: '您的密码为初始密码，为了您的账号安全请修改您的密码!',
                        type: 'error',
                        customClass:'z-index2003'
                    });
                }
            },

            //跳转页
            OpenLink(id){
                if(id == 1){
                    //会员中心
                    this.$router.push({ path: '/' });
                }else if(id == 2){
                    //站内信提示
                    // this.$router.push({ path: '/SiteMessage' });
                }else if(id == 3){
                    //内容管理
                    // this.$router.push({ path: '/CMSModule' });
                }else if(id == 4){
                    //消息中心
                    this.$router.push({ path: '/MessageCentre' });
                }
            },

            //密码框限制输入空格和中文
            newpass(val){
                this.EditPassForm.newPassword = this.EditPassForm.newPassword.replace(/[\u4E00-\u9FA5|\s]*/g,"");
            },
            reNewpass(val){
                this.EditPassForm.reNewPassword = this.EditPassForm.reNewPassword.replace(/[\u4E00-\u9FA5|\s]*/g,"");
            },
        },
        mounted(){

            //案件详情页默认收缩菜单
            if(this.$route.query.asidehide == 1){ 
                this.isActive = true;
                this.asideactive = false;
            }
            
           //获取已登录用户信息
            let user = JSON.parse(localStorage.getItem('user'));
			if (user) {
                this.username = user.memberInfo.user_name;
				this.realname = user.memberInfo.real_name;
                this.head_img = user.memberInfo.head_img;
                this.sub_sign = user.memberInfo.sub_sign;
                this.pass_status = user.memberInfo.pass_status;
                this.ver_type = String(user.memberInfo.ver_type)
                this.mem_type = user.memberInfo.mem_type;
                if(user.memberInfo.commitment_status == "1"){
                    this.legalProtocol = false
                } else {
                    this.legalProtocol = true
                }
            }

            // if(user.memberInfo.login_idcard != 1 && user.memberInfo.mem_type != 1){
            //     if(user.memberInfo.idcard_status != 2){
            //         localStorage.clear();
            //         sessionStorage.clear();
            //         this.$router.push({ path: '/Login' });
            //     }
            // }

            //获取委托方/批次号--针对查询条件
            this.common.getEntrustBill()
            .then( res=>{
                sessionStorage.setItem('entrust',JSON.stringify(res.data.data.entrustlist));
                sessionStorage.setItem('bill',JSON.stringify(res.data.data.billlist));
            })

            //获取委托方
            this.common.OpenEntrusts()
            .then( res=>{
                sessionStorage.setItem('entrusts',JSON.stringify(res.data.data));
            })
            //获取委托方-当前用户所有
            this.common.OpenentrustAll()
            .then( res=>{
                sessionStorage.setItem('entrustsAll',JSON.stringify(res.data.data));
            })
            //获取批次号
            this.common.AllgetBills()
            .then( res=>{
                sessionStorage.setItem('bills',JSON.stringify(res.data.data));
            })
            //获取催收员
            this.common.memNodes()
            .then( res=>{
                sessionStorage.setItem('memNodes',JSON.stringify(res.data.data));
            })
            //获取催收员--穿梭框
            this.common.memNodeList()
            .then( res=>{
                sessionStorage.setItem('memNodeList',JSON.stringify(res.data.data));
            })
            //获取户籍地
            this.common.CityArea()
            .then( res=>{
                sessionStorage.setItem('CityArea',JSON.stringify(res.data.data));
            })
            //获取省市
            this.common.getProAndCity()
            .then( res=>{
                sessionStorage.setItem('ProCity',JSON.stringify(res));
            })
            //获取催收状态
            this.common.getnoteLinkage()
            .then( res=>{
                sessionStorage.setItem('noteLinkage',JSON.stringify(res.data.data));
            })
        },
        watch: {
            editPass(val){
                if(!val){
                    this.EditPassForm.newPassword = '';
                    this.EditPassForm.reNewPassword = '';
                    this.$refs['EditPassForm'].resetFields();
                }
            }
        }
    }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Header.vue